/**
 * Class to be used as a base class for custom serializers. The serialize() and deserialize() methods are invoked
 * when serializing and deserializing data, respectively. This is useful for converting between different data types, such
 * as receiving a string from an API and converting it to a Date object.
 *
 * @class
 * @abstract
 * @name CustomSerializer
 * @example
 * ```typescript
 * class DateSerializer extends CustomSerializer {
 *   deserialize(data: string): Date {
 *     return new Date(data);
 *   }
 *
 *   serialize(data: Date): string {
 *     return data.toISOString();
 *   }
 * }
 * ```
 */
export class CustomSerializer {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	serialize(_data: any) {
		throw new Error(`serialize() not implemented for ${this.constructor.name}`);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	deserialize(_data: any) {
		throw new Error(`deserialize() not implemented for ${this.constructor.name}`);
	}
}

export type CustomSerializerClass = new () => CustomSerializer;
